export const SEARCH_TABS = {
  all: 0,
  movies: 1,
  tvShows: 2,
  sportsVod: 3,
  liveTv: 4,
};

export const SEARCH_CONTENT_TABS = [SEARCH_TABS.movies, SEARCH_TABS.tvShows, SEARCH_TABS.sportsVod, SEARCH_TABS.liveTv];

export const SEARCH_ROUTE_QUERY = {
  query: 'query',
  tab: 'tab',
};

export const SEARCH_TAB_OPTIONS = [
  { id: SEARCH_TABS.all, text: 'search.all', placeholder: 'search.searchsearch' },
  { id: SEARCH_TABS.movies, text: 'search.movies', placeholder: 'search.searchmovies' },
  { id: SEARCH_TABS.tvShows, text: 'search.tvShows', placeholder: 'search.searchtvshows' },
  { id: SEARCH_TABS.sportsVod, text: 'search.sportsVOD', placeholder: 'search.searchsports' },
  { id: SEARCH_TABS.liveTv, text: 'search.channels', placeholder: 'search.searchlivetv' },
];

export const SEARCH_SKELETON_COUNT = 5;
